import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgHub = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		clipRule: "evenodd",
		d: "M20 3C21.1046 3 22 3.89543 22 5V14C22 15.1046 21.1046 16 20 16H18V21C18 21.5523 17.5523 22 17 22H7C6.44772 22 6 21.5523 6 21V16H4C2.89543 16 2 15.1046 2 14V5C2 3.89543 2.89543 3 4 3H20ZM8 20H16V16H8V20ZM4 14H6V5H4V14ZM7.5 14H9.5V5H7.5V14ZM11 14H13V5H11V14ZM18 14H20V5H18V14ZM14.5 14H16.5V5H14.5V14Z",
		fill: "currentColor"
	})
});
export default SvgHub;
